import { COLORS } from "../../assets/utils/enums/colors";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { tableColumnType, TableTypeEnum } from "../../assets/utils/enums/table";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import StatisticBlock, {
  DataStatisticProps,
} from "../../components/ui/statistics-block";
import DataTable from "../../components/ui/table";
import basketIcon from "../../assets/images/icons/basket-icon.svg";
import { ClientRow } from "../../assets/utils/table-types";
import { useEffect, useState } from "react";
import getData from "../../api/project-request";
import { API_URL_CONTACT } from "../../constants";
import { deleteArrFunc } from "../../assets/utils/request-function";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
import { findStructureFieldByKey, useStructureStore } from "../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../assets/utils/enums/basket";
import { useStructureColumnsStore } from "../../assets/store/useStructureColumnsStore";

export default function ClientMainPage() {
  const [clients, setClients] = useState<ClientRow[]>([]);
  const [loaderState, setLoaderState] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const { period } = useStatisticPeriod();
  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.CLIENTS].fields
  )
  const baseColumns =
    tableColumnType[TableTypeEnum.CLIENTS].columns;

  const tableStructure = useStructureColumnsStore(
    baseColumns,
    fields
  );

  const [clientStatistic, setClientStatistic] = useState<DataStatisticProps[]>(
    []
  );

  const getClients = async () => {
    setLoaderState(true);
    try {
      const data = await getData(`${API_URL_CONTACT}/get-all-clients`);
      if (Array.isArray(data)) {
        setClients(data);
      } else {
        setClients([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setClients([]);
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 100);
    }
  };
  useEffect(() => {
    getClients();
    setIsDeleted(false);
  }, [isDeleted]);

  useEffect(() => {
    getClients();
  }, []);

  useEffect(() => {
    const getStatisticProject = async () => {
      const data = await getData(
        `${API_URL_CONTACT}/contact-statistic?period=${period}`
      );
      setClientStatistic([
        {
          title: "Потенційні",
          value: data.potentialCount,
          percent: data.potentialGrowthPercent,
        },
        {
          title: "Активні",
          value: data.activeCount,
          percent: data.activeGrowthPercent,
        },
        {
          title: "Втрачені",
          value: data.lostCount,
          percent: data.lostGrowthPercent,
        },
      ]);
    };

    setLoaderState(true);
    setTimeout(() => {
      getStatisticProject();
      setLoaderState(false);
    }, 200);
  }, [period, isDeleted]);

  return (
    <AppLayout className="" blockType="projects" loaderState={loaderState}>
      <Headline
        headline={HeadlineTypeEnum.CLIENTS}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Додати клієнта"
        btn_link="/clients/add"
      />
      {findStructureFieldByKey(fields, "customerType")?.visible && <div data-class="statistics-block" className="align-items-center w-50">
        {/* <StatisticBlock
          iconColor={COLORS.main1}
          iconUrl={userIconDark}
          bgColor={COLORS.white}
          isDropdown={true}
          data={clientStatistic}
        /> */}
        <StatisticBlock
          iconColor={COLORS["bg-text-color"]}
          iconUrl={basketIcon}
          bgColor={COLORS.white}
          isDropdown={true}
          data={clientStatistic}
        />
      </div>}
      <DataTable
        key={JSON.stringify(tableStructure.map(c => `${c.key}-${c.label}-${c.visible}`))}
        table={{ ...tableColumnType[TableTypeEnum.CLIENTS], columns: tableStructure }}
        data={clients}
        deleteArrFunc={(queryArr) =>
          deleteArrFunc(
            queryArr,
            `${API_URL_CONTACT}/delete-client`,
            setIsDeleted
          )
        }
      />
    </AppLayout>
  );
}
